import React, { useState } from "react";
import styles from "./BeltDrawer.module.css";

export interface BeltOption {
  value: string;
  label: string;
}

interface BeltDrawerProps {
  value: string[];
  onChange: (selected: string[]) => void;
  options: BeltOption[];
  groups: { key: string; label: string; values: string[] }[];
}

const BeltDrawer: React.FC<BeltDrawerProps> = ({ value, onChange, options, groups }) => {
  const [open, setOpen] = useState(false);

  // Gestion des groupes
  const handleGroupToggle = (groupKey: string) => {
    const group = groups.find(g => g.key === groupKey);
    if (!group) return;
    const isAllSelected = group.values.every(v => value.includes(v));
    let newSelected: string[];
    if (isAllSelected) {
      newSelected = value.filter(v => !group.values.includes(v));
    } else {
      newSelected = Array.from(new Set([...value, ...group.values]));
    }
    onChange(newSelected);
  };

  // Gestion individuelle
  const handleToggle = (belt: string) => {
    if (value.includes(belt)) {
      onChange(value.filter(v => v !== belt));
    } else {
      onChange([...value, belt]);
    }
  };

  // Vérifier si un groupe est entièrement sélectionné
  const isGroupSelected = (groupKey: string) => {
    const group = groups.find(g => g.key === groupKey);
    if (!group) return false;
    return group.values.every(v => value.includes(v));
  };

  return (
    <>
      <button className={styles.drawerButton} onClick={() => setOpen(true)}>
        Filtres ceintures
      </button>
      <div className={styles.drawer + (open ? ' ' + styles.open : '')}>
        <div className={styles.drawerHeader}>
          <span>Filtrer par ceinture</span>
          <button className={styles.closeButton} onClick={() => setOpen(false)}>&times;</button>
        </div>
        <div className={styles.groupsSection}>
          {groups.map(g => (
            <label key={g.key} className={styles.groupLabel}>
              <input
                type="checkbox"
                checked={isGroupSelected(g.key)}
                onChange={() => handleGroupToggle(g.key)}
              />
              {g.label}
            </label>
          ))}
        </div>
        <div className={styles.optionsSection}>
          {options.map(opt => (
            <label key={opt.value} className={styles.optionLabel}>
              <input
                type="checkbox"
                checked={value.includes(opt.value)}
                onChange={() => handleToggle(opt.value)}
              />
              {opt.label}
            </label>
          ))}
        </div>
      </div>
      {open && <div className={styles.overlay} onClick={() => setOpen(false)} />}
    </>
  );
};

export default BeltDrawer; 